import MainApp from '@/components/MainApp.vue'
import { allRoles, lazyLoadView, redirectHome, _, isAuthorized } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

// /app/... are routes that are neither in the menu nor in the wheel menu

export const appRoutes: RouteConfig[] = [
  {
    path: '/app',
    name: 'common',
    component: MainApp,
    redirect: () => redirectHome(),
    meta: {
      dummy: true,
    },
    children: [
      {
        path: '/my_objects',
        name: 'my_objects',
        component: () => lazyLoadView(import('@/contexts/administration/AdministrationUserObjectsView.vue')),
        meta: {
          title: null,
          icon: 'boxes',
          is_authorized: (route: Route) => isAuthorized(route),
          requires_auth: true,
          requires_tenant: true,
          requires_role: allRoles,
          doc_id: 'my_objects',
        },
      },
      {
        path: '/doc',
        name: 'documentation',
        component: () => lazyLoadView(import('@/contexts/documentation/DocumentationView.vue')),
        meta: {
          title: _('Documentation'),
          is_authorized: (route: Route) => isAuthorized(route),
          requires_auth: true,
          requires_tenant: false,
          requires_role: allRoles,
          doc_id: 'documentation',
        },
      },
      {
        path: '/doc/:id',
        name: 'doc_link',
        component: () => lazyLoadView(import('@/contexts/documentation/DocumentationView.vue')),
        meta: {
          title: _('Documentation'),
          is_authorized: (route: Route) => isAuthorized(route),
          requires_auth: true,
          requires_tenant: false,
          requires_role: allRoles,
          doc_id: 'documentation',
        },
      },
    ],
  },
]
